import { getStoredLanguage, normalizeLanguageCode } from "../utils/language";

export const getApiLanguage = () => normalizeLanguageCode(getStoredLanguage());

export const withApiLanguageHeader = (headers = {}) => ({
  ...headers,
  "Accept-Language": getApiLanguage(),
});
